import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {ThemeProvider} from "@design-system-rt/rtk-ui-kit";


ReactDOM.render(<App/>, document.getElementById('root'));

